// Delete this file when removing the
import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const Line = () => (
	<Container>
		<LineDiv />
	</Container>
);

export default Line;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LineDiv = styled.div({
	display: 'flex',
	boxSizing: 'border-box',
	height: '1px',
	width: '100%',
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: `${token('color.icon.danger')}`,
});
